export default __webpack_public_path__ + "static/v-confident-35bda858724d22672892cdd73582cd85.webp";